export default __webpack_public_path__ + "static/media/twinstar.e3f98ff1.jpg";